import { i18n } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import React from 'react';

export function FileConfBox({ file, fileIdx, removeFile, change, label, scaricaDocument, isInEditMode }) {
    return (
        <div className="single-file mb-2" key={'file_' + fileIdx}>
            <div>
                <i className="file-icon fa fa-file" style={{ marginRight: '0.5rem', color: '#4ccbab' }} />
                {
                    // file.docId ?
                    !isInEditMode ?
                        <span className="lab">{i18n("ARM_CORE_PRINT.CONTENT_UPLOAD", 'Documento da uplodare')} </span>
                        :
                        <span className="lab">{label}</span>
                }
                <div className="file-name mb-2">
                    {' '}
                    <b>{file.fileName}</b>
                </div>
            </div>

            {
                // file.docId ?
                isInEditMode ?
                    <agui.aButton
                        bs="danger"
                        className="del-btn"
                        outline={true}
                        icon="fas fa-trash"
                        small={true}
                        title={i18n("ARM_CORE_PRINT.RIMUOVI_FILE", "Rimuovi content")}
                        onClick={() => removeFile()}
                    ></agui.aButton>
                    :
                    <agui.aButton
                        bs="primary"
                        className="del-btn"
                        outline={true}
                        icon="fas fa-download"
                        small={true}
                        title={i18n("ARM_CORE_PRINT.SCARICA_FILE", "Scarica content")}
                        onClick={() => scaricaDocument(file.docId)}
                    ></agui.aButton>
            }
        </div>
    )
}